export default {
  biFormsBySiteAndDate: 'BI_FORMS_BY_SITE_AND_DATE',
  biFormsByDate: 'BI_FORMS_BY_DATE',
  setLoadingState: 'BI_FORMS_SET_LOADING_STATE',
};
